import { useEffect } from 'react';

const SITE = 'Armed Fire Services';

function setMeta(selector, attr, value) {
  if (!value) return;
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement('meta');
    const [, key, name] = selector.match(/\[(\w+)="([^"]+)"\]/) || [];
    if (key) el.setAttribute(key, name);
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
}

/** Per-route document title, description and og tags for the client-rendered site. */
export default function useSeo({ title, description, image } = {}) {
  useEffect(() => {
    const full = title ? `${title} | ${SITE}` : `${SITE} | Fire Protection, Security & Safety Training, Bengaluru`;
    document.title = full;
    setMeta('meta[name="description"]', 'content', description);
    setMeta('meta[property="og:title"]', 'content', full);
    setMeta('meta[property="og:description"]', 'content', description);
    setMeta('meta[property="og:image"]', 'content', image);
    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (canonical) canonical.setAttribute('href', `https://www.armedfire.in${window.location.pathname}`);
  }, [title, description, image]);
}
